var exports = {
  "H": "sidebarToggleButton__gxYQsK",
  "t": "sidebarHeading__wLa7mg",
};

module.exports = exports;
